import React from "react";

import { ThemeProvider } from "@emotion/react";
import { CssBaseline } from "@mui/material";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Router } from "pages/Router";
import { theme } from "util/config/muiThemeConfig";

import { PermissionsProvider } from "./context/PermissionsContext";
import { TeamsAndChannelsProvider } from "./context/TeamsAndChannelsContext";

import "./css/app.css";
import "./css/global.css";
import "./css/modals.css";
import "./css/navbar.css";

const queryClient = new QueryClient();
function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <PermissionsProvider>
        <TeamsAndChannelsProvider>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <div
              data-testid="App"
              style={{
                width: "100vw",
                height: "calc(100vh - 64px - 52px)",
                backgroundColor: "#F8F8F8",
              }}
            >
              <Router />
            </div>
            <ReactQueryDevtools initialIsOpen={false} />
          </ThemeProvider>
        </TeamsAndChannelsProvider>
      </PermissionsProvider>
    </QueryClientProvider>
  );
}

function AppWrapper() {
  return <App />;
}

export default AppWrapper;
